import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { COMPANY_ADMIN, SYS_ADMIN } from 'config/permissions/roles';
import regulatorAddForm from './regulator-add-form/regulator-add-form.module';
import regulatorEditForm from './regulator-edit-form/regulator-edit-form.module';
import regulatorComponent from './regulator.component';

export default
  angular.module('components.app.admin.regulator', [
    uiRouter,
    regulatorAddForm,
    regulatorEditForm
  ])
    .component('regulator', regulatorComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('regulator', {
          parent: 'app',
          url: '/regulators/{id:int}',
          component: 'regulator',
          data: {
            permissions: {
              only: [COMPANY_ADMIN, SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          },
          resolve: {
            accessLevels: AuthService => AuthService.getAccessLevels(),
            regulator: (RegulatorService, $stateParams) =>
              RegulatorService.get($stateParams.id).then(r => r.data),
            user: (AccountService, AuthService, currentUser) =>
              AccountService.getAccount(currentUser.UserId).then(r => r.data),
            locked: () => true
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator.module.js